<div class="relative">
  <div class="p-6 flex justify-between">
    <div class="flex flex-col gap-2">
      <ciwc-manage-saved-lists
        #manageSavedLists
        [listId]="listId"
        (saveList)="onSaveList($event)"
      ></ciwc-manage-saved-lists>
    </div>

    <div class="w-64">
      <div class="bg-white rounded shadow-md p-4">
        <h3 class="text-gray-600 font-normal mb-4 pb-2">Options</h3>

        <button
          class="py-3 flex justify-between items-center hover:text-blue-500 w-full"
          (click)="manageSavedLists.submit()"
          [disabled]="loading$()"
        >
          <mat-spinner *ngIf="loading$()" diameter="20"></mat-spinner>
          <span>Save List Changes</span>
          <mat-icon>edit</mat-icon>
        </button>

        <button
          class="w-full font-normal py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
          (click)="deleteList()"
        >
          <span>Delete</span>
          <mat-icon>delete</mat-icon>
        </button>

        <button
          class="w-full font-normal py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
          (click)="exportList('csv')"
        >
          <span>Export</span>
          <mat-icon>print</mat-icon>
        </button>

        <button
          class="w-full font-normal py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
          (click)="exportList('pdf')"
        >
          <span>Export as PDF</span>
          <mat-icon>print</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <ciwc-saved-list-table [listId]="listId"></ciwc-saved-list-table>
</div>
